import detailsGraphs from '@/utils/templates/vmTemplates/details.graphs.config';
import detailsGraphsWindows from '@/utils/templates/vmTemplates/windows.details.graphs.config';

const vm = {
  details: [
    detailsGraphs().areaCharts,
    detailsGraphs().lineCharts,
    detailsGraphs().forecastDisabledAreaChart,
  ],
  detailsWindows: [
    detailsGraphsWindows().gaugeCharts,
    detailsGraphsWindows().areaCharts,
    detailsGraphsWindows().forcastDisabledLineAreaCharts,
  ],
};
export default vm;
